<template>
  <div style="position: relative; height: 700px">
    <div v-if="loading" class="loading-div">
      <Button loading shape="circle" type="primary"></Button>
      <div>loading...</div>
    </div>
    <Form inline class="bill-form">
      <FormItem>
        <Input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 2 }"
          v-model="searchData.keywords"
          :placeholder="$t('keyword')"
        >
        </Input>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="SearchSubmit" icon="md-search">
          {{ $t("search") }}
        </Button>
      </FormItem>
      <FormItem>
        <Button
          type="warning"
          icon="ios-cloud-upload-outline"
          @click="handUpload"
          v-if="$hasPermission(887)"
        >
          {{ $t("updateFile") + $t("Appendix") }}
        </Button>
      </FormItem>
      <FormItem>
        <Button
          type="error"
          icon="md-trash"
          @click="hangClick"
          :disabled="selectAll.length == 0 || row.status == 9"
          v-if="$hasPermission(885)"
        >
          {{ $t("hang") }}
        </Button>
      </FormItem>
      <FormItem>
        <Button
          type="error"
          icon="md-trash"
          @click="deleteClick"
          :disabled="selectAll.length == 0 || row.status == 9"
          v-if="$hasPermission(886)"
        >
          {{ $t("delete") }}
        </Button>
      </FormItem>
      <FormItem>
        <Dropdown transfer>
          <Button type="primary" v-if="$hasPermission(423)">
            {{ $t("export") }}
            <Icon type="ios-arrow-down"></Icon>
          </Button>
          <DropdownMenu slot="list">
            <DropdownItem>
              <Button
                style="width: 100%"
                type="info"
                size="small"
                @click="exportExc(1)"
                :disabled="selectAll.length == 0"
              >
                {{ $t("selected") + $t("list") }}
              </Button>
            </DropdownItem>
            <DropdownItem>
              <Button
                style="width: 100%"
                type="error"
                size="small"
                @click="exportExc(2)"
              >
                {{ $t("bill1") + $t("detail") }}
              </Button>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </FormItem>
    </Form>
    <vxe-table
      border
      stripe
      resizable
      show-overflow
      highlight-hover-row
      ref="xTable"
      :height="560"
      align="center"
      :data="tableData"
      :edit-config="{ trigger: 'click', mode: 'cell' }"
      :scroll-y="{ mode: 'wheel' }"
      @checkbox-change="selectTableAll"
      @checkbox-all="selectTableAll"
    >
      <vxe-column
        v-for="config in tableTitle"
        :key="config.key"
        :type="config.type"
        :field="config.key"
        :title="config.title"
        :width="config.minWidth"
      >
      </vxe-column>
    </vxe-table>
    <div>
      <div class="price-content">
        <div v-for="(item, index) in priceList" :key="index">
          <span class="span-head">
            {{ $t("originalCodAmount") }}{{ item.replace_currency }}:
          </span>
          <span class="span-title">
            {{ item.total_amount }}
          </span>
        </div>
        <span
          class="span-head"
          style="border-left: 1px solid #ccc; padding-left: 10px"
        >
          {{ $t("total") + $t("bill_proceeds_issuing") + "USD" }}:
        </span>
        <span class="span-title">
          {{ row.total_amount }}
        </span>
      </div>
      <Page
        ref="pageSize"
        :page-size-opts="arrPageSize"
        :total="total"
        show-sizer
        :page-size="searchData.pageSize"
        @on-page-size-change="changeSize"
        @on-change="changePage"
        show-elevator
        show-total
        :current.sync="pageCurrent"
        style="margin-top: 0"
      />
    </div>
    <Modal
      v-model="showModal"
      :title="title"
      @on-visible-change="closedeleteModal"
      width="600"
      class-name="vertical-center-modal"
    >
      <template v-if="title == $t('updateFile') + $t('Appendix')">
        <Form
          label-position="right"
          :model="uploadData"
          :label-width="130"
          ref="uploadData"
        >
          <FormItem :label="$t('updateFile') + $t('Appendix')">
            <Upload
              ref="upload"
              accept=".xls, .xlsx"
              :before-upload="handleUpload"
              action=""
            >
              <Button icon="ios-cloud-upload-outline">{{
                $t("checkFile")
              }}</Button>
            </Upload>
            <div
              class="file-list"
              v-for="(item, index) in fileList"
              :key="item.id"
            >
              <div class="file-name" @click="download(item.src)">
                {{ item.file_name }}
              </div>
              <div class="file-btn">
                <Icon
                  type="ios-trash-outline"
                  @click.native="delFile(index, item.id)"
                >
                </Icon>
              </div>
            </div>
          </FormItem>
          <FormItem :label="$t('deductExpenses')">
            <InputNumber
              v-model="uploadData.deductible_fee"
              :step="0.01"
              style="width: 100%"
            ></InputNumber>
          </FormItem>
          <FormItem :label="$t('receivable') + $t('otherCost')">
            <InputNumber
              v-model="uploadData.other_fee"
              style="width: 100%"
              :min="0"
              :step="0.01"
            ></InputNumber>
          </FormItem>
        </Form>
      </template>
      <template v-else>
        <Form
          label-position="right"
          :model="dataDetails"
          :label-width="120"
          :rules="ruleFrom"
          ref="dataDetails"
        >
          <template v-if="title == $t('hang')">
            <FormItem :label="$t('order_desc')" prop="remarks">
              <Input
                type="textarea"
                v-model="dataDetails.remarks"
                placeholder="Please enter remarks"
                :rows="4"
              >
              </Input>
            </FormItem>
          </template>
        </Form>
      </template>
      <div slot="footer" class="footer-modal">
        <Button type="text" @click="closeModal">{{ $t("cancel") }}</Button>

        <Button type="primary" @click="confirmModal('dataDetails')">
          {{ $t("confirm") }}
        </Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import {
  getDetails,
  del,
  deleteShipment,
  exportBillDetails,
  getExtFile,
  uploadExtFile,
  delExtFile,
  saveExtFile,
} from "@/api/finance/codList";
import excel from "@/utils/excel";
import boxMes from "@/utils/message";
export default {
  inject: ["$page"],
  props: {
    row: {
      type: Object,
    },
    close: {
      type: Function,
    },
  },
  data() {
    return {
      searchData: {
        page: 1,
        pageSize: 15,
        keywords: "",
      },
      arrPageSize: [15, 100, 500, 1000],
      tableData: [],
      total: 0,
      loading: true,
      pageCurrent: 1,
      showModal: false,
      ruleFrom: {
        remarks: [
          {
            required: true,
            message: "Please Enter remarks",
            trigger: "blur",
          },
        ],
      },
      dataDetails: {},
      typeList: ["RECEIVE", "REFUND"],
      hideSelect: true,
      selectAll: [],
      title: "",
      priceList: [],
      uploadData: {},
      fileList: [],
      disabledDown: false,
    };
  },
  computed: {
    tableTitle() {
      let columns = [];
      if (this.hideSelect) {
        columns.push({
          type: "checkbox",
          width: 60,
          align: "center",
        });
      }
      columns.push({
        title: this.$t("outboundTime"),
        key: "outbound_time",
        align: "center",
        minWidth: 170,
      });
      columns.push({
        title: this.$t("clientName"),
        key: "account",
        minWidth: 100,
        align: "center",
        tooltip: "true",
      });
      columns.push({
        title: this.$t("order_number"),
        key: "airway_bill_number",
        align: "center",
        minWidth: 130,
      });
      columns.push({
        title: this.$t("channel_code"),
        key: "transport_mode",
        align: "center",
        minWidth: 100,
        tooltip: "true",
      });
      columns.push({
        title: this.$t("target_country"),
        key: "to_country",
        align: "center",
        minWidth: 100,
        tooltip: "true",
      });
      columns.push({
        title: this.$t("city_name"),
        key: "city_name",
        align: "center",
        minWidth: 100,
        tooltip: "true",
      });
      columns.push({
        title: this.$t("shipperRef"),
        key: "client_refer_code",
        align: "center",
        minWidth: 110,
        tooltip: "true",
      });
      columns.push({
        title: this.$t("agentName"),
        key: "deliver",
        align: "center",
        minWidth: 100,
        tooltip: "true",
      });
      // columns.push({
      //   title: this.$t("17no"),
      //   key: "17no",
      //   align: "center",
      //   minWidth: 100,
      //   tooltip: "true"
      // });
      columns.push({
        title: this.$tz("最新,轨迹代码"),
        key: "status",
        align: "center",
        minWidth: 130,
      });
      columns.push({
        title: this.$t("status_time"),
        key: "status_time",
        align: "center",
        minWidth: 170,
      });
      columns.push({
        title: this.$tz("POD,时间"),
        key: "pod_time",
        align: "center",
        minWidth: 170,
      });
      columns.push({
        title: this.$t("codAmount"),
        key: "cod_amount",
        align: "center",
        minWidth: 120,
      });
      // if (this.codStatus == "REFUND") {
      columns.push({
        title: this.$t("cod_ncnd_9_time"),
        key: "cod_ncnd_9_time",
        align: "center",
        minWidth: 170,
      });
      columns.push({
        title: this.$t("cod_status"),
        key: "cod_status",
        align: "center",
        minWidth: 100,
      });
      columns.push({
        title: this.$t("rate"),
        key: "cod_client_rate",
        align: "center",
        minWidth: 100,
      });
      columns.push({
        title: this.$t("bill_close_account_issuing"),
        key: "bill_close_account_issuing",
        align: "center",
        minWidth: 120,
      });
      columns.push({
        title: this.$t("bill_close_account_issuing_charge"),
        key: "bill_close_account_issuing_charge",
        align: "center",
        minWidth: 100,
      });
      columns.push({
        title: this.$t("VATFee"),
        key: "bill_close_account_issuing_vat",
        align: "center",
        minWidth: 100,
      });
      columns.push({
        title: this.$t("bill_close_account_issuing_confirm"),
        key: "bill_close_account_issuing_confirm",
        align: "center",
        minWidth: 100,
      });
      columns.push({
        title: this.$t("cod_1_time"),
        key: "cod_1_time",
        align: "center",
        minWidth: 170,
      });
      columns.push({
        title: this.$t("cod_9_time"),
        key: "cod_9_time",
        align: "center",
        minWidth: 170,
      });
      // } else {
      //   columns.push({
      //     title: this.$t("cod_ncnd_status"),
      //     key: "cod_ncnd_status",
      //     align: "center",
      //     minWidth: 100
      //   });
      //   columns.push({
      //     title: this.$t("rate"),
      //     key: "cod_agent_rate",
      //     align: "center",
      //     minWidth: 100
      //   });
      //   columns.push({
      //     title: this.$t("bill_proceeds_issuing"),
      //     key: "bill_proceeds_issuing",
      //     align: "center",
      //     minWidth: 120
      //   });
      //   columns.push({
      //     title: this.$t("bill_proceeds_issuing_charge"),
      //     key: "bill_proceeds_issuing_charge",
      //     align: "center",
      //     minWidth: 100
      //   });
      //   columns.push({
      //     title: this.$t("bill_proceeds_issuing_confirm"),
      //     key: "bill_proceeds_issuing_confirm",
      //     align: "center",
      //     minWidth: 120
      //   });
      //   columns.push({
      //     title: this.$t("cod_ncnd_1_time"),
      //     key: "cod_ncnd_1_time",
      //     align: "center",
      //     minWidth: 170
      //   });
      // }
      return columns;
    },
  },
  mounted() {
    this.SearchSubmit();
  },
  methods: {
    download(src) {
      window.open(this.$globalUrl + src);
    },
    delFile(index, id) {
      this.fileList.splice(index, 1);
      delExtFile(this.row.id, id);
    },
    handUpload() {
      getExtFile(this.row.id).then((res) => {
        if (res.data.status) {
          this.uploadData = {
            deductible_fee: parseFloat(res.data.payload.deductible_fee),
            other_fee: parseFloat(res.data.payload.other_charges),
          };
          this.fileList = res.data.payload.files;
          this.title = this.$t("updateFile") + this.$t("Appendix");
          this.showModal = true;
        } else {
          {
            this.$Message["error"]({
              background: true,
              content: res.data.msg,
            });
          }
        }
      });
    },
    deleteClick() {
      let data = {
        id: this.row.id,
        ids: this.selectAll.map((item) => item.id),
      };
      this.$Modal.confirm({
        title: this.$t("delete"),
        width: 300,
        content: this.$t("titleModal"),
        onOk: () => {
          deleteShipment(data).then((res) => {
            this.$Message[res.data.status ? "success" : "error"]({
              background: true,
              content: res.data.msg,
            });
            if (!res.data.payload.bill_del) {
              this.SearchSubmit();
            } else {
              this.close();
              this.$page.getList();
            }
          });
        },
      });
    },
    handleUpload(file) {
      this.addList(file);
      return false;
    },
    addList(file) {
      let formData = new FormData();
      formData.append("file", file);
      formData.append("batchNo", new Date().getTime()); // 文件对象
      uploadExtFile(this.row.id, formData).then((res) => {
        this.$Message[res.data.status ? "success" : "error"]({
          background: true,
          content: res.data.msg,
        });
        if (res.data.status) {
          this.fileList.push(res.data.payload);
        }
      });
    },
    hangClick() {
      this.title = this.$t("hang");
      if (this.selectAll.length == 0) {
        this.$Message["error"]({
          background: true,
          content: "Operation data cannot be empty",
        });
        return;
      }
      this.showModal = true;
    },
    selectTableAll(val) {
      this.selectAll = val.records;
    },
    exportExc(val) {
      if (val == 1) {
        this.hideSelect = false;
        let arr = this.tableTitle;
        arr.pop();
        excel.exportExcel(
          this.selectAll.length == 0 ? this.tableData : this.selectAll,
          arr,
          this.$t("cod_details") + "(" + this.row.check_bill_number + ")",
          this
        );
        this.hideSelect = true;
      } else {
        exportBillDetails(this.row.id).then((res) => {
          this.$Message[res.data.status ? "success" : "error"]({
            background: true,
            content: res.data.msg,
            duration: res.data.status ? 2 : 5,
          });
          if (res.data.status)
            window.open(this.$globalUrl + res.data.payload.src);
        });
      }
      this.SearchSubmit();
    },
    closeModal() {
      this.closedeleteModal(false);
    },
    closedeleteModal(e) {
      if (e === false) {
        this.showModal = false;
        this.searchData.keywords = "";
        if (this.title == this.$t("updateFile") + this.$t("Appendix")) {
          this.$refs["uploadData"].resetFields();
          return;
        }
        this.$refs["dataDetails"].resetFields();
      }
    },
    confirmModal(name) {
      if (this.title == this.$t("updateFile") + this.$t("Appendix")) {
        saveExtFile(this.row.id, this.uploadData).then((res) => {
          if (res.data.status) {
            this.$Message["success"]({
              background: true,
              content: res.data.msg,
            });
            this.closeModal();
          } else {
            this.$Message["error"]({
              background: true,
              content: res.data.msg,
              duration: 5,
            });
          }
        });
        return;
      }
      this.$refs[name].validate((valid) => {
        if (valid) {
          let arr = this.selectAll.map((item) => {
            return item.id;
          });
          this.deleteList(arr);
        }
      });
    },
    deleteList(data) {
      this.dataDetails.ids = data;
      del(this.row.id, this.dataDetails).then((res) => {
        if (res.data.status) {
          this.$Message["success"]({
            background: true,
            content: res.data.msg,
          });
          if (!res.data.payload.bill_del) {
            this.SearchSubmit();
          } else {
            this.close();
            this.$page.getList();
          }
        } else {
          this.$Message["error"]({
            background: true,
            content: res.data.msg,
            duration: 5,
          });
        }
      });
    },
    getList(id, data) {
      this.tableData = [];
      this.priceList = [];
      this.loading = true;
      getDetails(id, data)
        .then((res) => {
          if (!res.data.status) {
            this.loading = false;
            boxMes.alertMes(res, this);
            return;
          }
          this.tableData = res.data.payload.rows;
          this.priceList = res.data.payload.totalCurrency;
          this.total = res.data.payload.total;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeSize(val) {
      this.searchData.pageSize = val;
      this.SearchSubmit();
    },
    changePage(val) {
      this.searchData.page = val;
      this.SearchSubmit();
    },
    SearchSubmit() {
      this.getList(this.row.id, this.searchData);
    },
  },
};
</script>

<style scoped lang="less">
.price-content {
  display: flex;
  height: 40px;
  align-items: center;
  justify-content: flex-end;
}
.delBtn {
  margin: 0 10px;
}
.ivu-page {
  margin-top: 20px;
}
.footer-modal {
  width: 100%;
}
.bill-form .ivu-form-item {
  margin-bottom: 10px;
}
.text-red {
  color: red;
  font-weight: bold;
}
.file-list {
  display: flex;
  align-items: center;
  height: 30px;
  justify-content: space-between;
  border-bottom: 1px solid #e8eaec;
}
.file-name {
  width: ~"calc(100% - 50px)";
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
.file-list .file-btn {
  font-size: 20px;
}
</style>
